<template>
  <div id="bbrCom_gameResult">
    <h4>{{ getFormattedToday(json.gameDate) }}の日本人選手成績</h4>
    <template v-if="json.japaneseInfo.length">
      <div class="bbrCom_japanese">
        <div v-for='(info, index) in json.japaneseInfo' v-bind:key="index" class="bbrCom_japanese_item">
          <a v-bind:href="getGameLink($config.baseUrl, info.game)">
            <div>
              <div v-bind:class="'bbrCom_japanese bbrCom_japanese_player bbrCom_bgTeam' + info.player.teamId">
                <div class="bbrCom_japanese_column">
                  <div>{{ info.player.name }} {{ info.player.positon }} {{ info.player.team }}</div>
                </div>
                <div class="bbrCom_japanese_column">
                  <div class="bbrCom_japanese_game">試合詳細</div>
                </div>
              </div>
              <table v-if="info.batting != null" class="">
                <thead>
                  <tr>
                    <th>打数</th>
                    <th>安打</th>
                    <th>打点</th>
                    <th>本塁打</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ info.batting.atBats }}</td>
                    <td>{{ info.batting.hits }}</td>
                    <td>{{ info.batting.runs }}</td>
                    <td>{{ info.batting.homeRuns }}</td>
                  </tr>
                </tbody>
              </table>
              <table v-if="info.pitching != null" class="">
                <thead>
                  <tr>
                    <th>投球回</th>
                    <th>球数</th>
                    <th>被安打</th>
                    <th>奪三振</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ info.pitching.inningsPitched }}</td>
                    <td>{{ info.pitching.pitchCount }}</td>
                    <td>{{ info.pitching.hits }}</td>
                    <td>{{ info.pitching.strikeOuts }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </a>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="bbrCom_japanese_none">日本人選手が出場する試合はありません。</div>
    </template>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      json: null,
    }
  },
  mounted: function() {
  },
  methods: {
    getFormattedToday: function (date) {
      return this.$moment(date).format('YYYY.MM.DD (ddd)');
    },
    getGameLink: function (baseUrl, game) {
      let url = baseUrl;
      if (game.gameStatus == 2 || game.gameStatus == 123) {
        url += '?kd_page=pbp&global_id=' + game.gameGlobalId;
      } else {
        url += '?kd_page=game&global_id=' + game.gameGlobalId;
      }
      return url;
    },
  }
}
</script>